import styled from "styled-components";

export const NormalText = styled.p`
    color: #000;
    font-size: 0.938rem;
    font-weight: 400;
    line-height: normal;
`;

export const SemiBoldText = styled.h6`
    font-size: 1.063rem;
    font-weight: 800;
    line-height: 20px;
    color: #000000;
`;

export const SmallHeaderText = styled.h4`
    color: #000;
    font-size: 1.25rem;
    font-weight: 900;
    line-height: 25px;
`;

export const HeaderText = styled.h2`
    color: #000;
    font-size: 1.75rem;
    font-weight: 800;
    line-height: 34px;
`;

export const MidHeaderText = styled.h3`
    font-size: 1.5rem;
    font-weight: 900;
    line-height: 30px;
    color: #000;
`;

export const ModalWrapper = styled.div`
    border-radius: 6px;
    border: 1px solid rgba(219, 220, 224, 0.5);
    background: #fff;
    box-shadow: 15px 30px 40px 0px rgba(0, 0, 0, 0.07);
    max-width: 100%;

    h3 {
        font-size: 1.25rem;
        font-weight: 900;
        line-height: 25px;
        color: #000;
        text-align: center;
    }
    .catalogue-modal__buttons-wrap {
        display: flex;
        align-items: center;
        width: 100%;
        justify-content: center;
        gap: 20px;
    }
`;
